import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <Section background="forest" className="text-center" data-id="element-179">
      <div className="mb-8" data-id="element-180">
        <h2 className="text-3xl md:text-5xl text-[#FDF8F0] mb-3" data-id="element-181">
          Sistema Doble Capa™
        </h2>
        <p className="text-[#FDF8F0]/80 text-lg max-w-2xl mx-auto" data-id="element-182">
          Este botiquín funciona como un "manual de decisión". No es solo
          información, es estrategia.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-183">
        {/* Layer 1 */}
        <motion.div whileHover={{
        y: -5
      }} className="bg-[#FDF8F0] text-[#1A1A1A] p-6 rounded-2xl shadow-xl text-left" data-id="element-184">
          <div className="text-[#C9963A] font-bold text-sm uppercase tracking-wider mb-2" data-id="element-185">
            Capa 1
          </div>
          <h3 className="text-2xl font-bold mb-3 text-[#1B4332]" data-id="element-186">
            Síntoma → Acción Simple
          </h3>
          <ul className="space-y-3 text-gray-700" data-id="element-187">
            <li className="flex items-center gap-2" data-id="element-188">
              <span className="w-2 h-2 bg-[#1B4332] rounded-full" data-id="element-189" />1 a 3
              opciones máximas (no listas eternas)
            </li>
            <li className="flex items-center gap-2" data-id="element-190">
              <span className="w-2 h-2 bg-[#1B4332] rounded-full" data-id="element-191" />
              Ingredientes accesibles (súper + farmacia)
            </li>
            <li className="flex items-center gap-2" data-id="element-192">
              <span className="w-2 h-2 bg-[#1B4332] rounded-full" data-id="element-193" />
              Pasos cortos y claros
            </li>
            <li className="flex items-center gap-2" data-id="element-194">
              <span className="w-2 h-2 bg-[#1B4332] rounded-full" data-id="element-195" />
              Qué esperar y en cuánto tiempo
            </li>
          </ul>
        </motion.div>

        {/* Layer 2 - Traffic Light */}
        <motion.div whileHover={{
        y: -5
      }} className="bg-[#FDF8F0] text-[#1A1A1A] p-6 rounded-2xl shadow-xl text-left relative overflow-hidden" data-id="element-196">
          <div className="text-[#C9963A] font-bold text-sm uppercase tracking-wider mb-2" data-id="element-197">
            Capa 2
          </div>
          <h3 className="text-2xl font-bold mb-4 text-[#1B4332]" data-id="element-198">
            Semáforo de Riesgo
          </h3>

          <div className="space-y-4" data-id="element-199">
            <div className="flex items-start gap-4 p-3 rounded-lg bg-green-50 border border-green-100" data-id="element-200">
              <div className="w-8 h-8 rounded-full bg-green-500 flex-shrink-0 shadow-sm animate-pulse" data-id="element-201" />
              <div data-id="element-202">
                <span className="font-bold text-green-800 block" data-id="element-203">Verde</span>
                <span className="text-sm text-green-700" data-id="element-204">
                  Podés probar en casa y observar.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 p-3 rounded-lg bg-yellow-50 border border-yellow-100" data-id="element-205">
              <div className="w-8 h-8 rounded-full bg-yellow-400 flex-shrink-0 shadow-sm" data-id="element-206" />
              <div data-id="element-207">
                <span className="font-bold text-yellow-800 block" data-id="element-208">
                  Amarillo
                </span>
                <span className="text-sm text-yellow-700" data-id="element-209">
                  Cautela + observación + considerar consulta.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 p-3 rounded-lg bg-red-50 border border-red-100" data-id="element-210">
              <div className="w-8 h-8 rounded-full bg-red-500 flex-shrink-0 shadow-sm" data-id="element-211" />
              <div data-id="element-212">
                <span className="font-bold text-red-800 block" data-id="element-213">Rojo</span>
                <span className="text-sm text-red-700" data-id="element-214">
                  No es para el botiquín casero: consultá ya.
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="mt-8 text-[#FDF8F0] font-medium text-xl" data-id="element-215">
        Esta es la diferencia entre "natural" y "responsable".
      </div>
    </Section>;
}